const btnSubcategoriesDesktop = document.querySelector('#subcategories-btn-desktop');
const btnSubcategoriesMobile = document.querySelector('#subcategories-btn-mobile');

const btnClose = document.querySelector('.subcategoriesTitleClose');

const subcategoriesOverlay = document.querySelector('.subcategories-overlay');
const subcategoriesWrapper = document.querySelector('.subcategoriesWrapper');

if (subcategoriesWrapper) {
  const subcategoriesPopup = () => {
		subcategoriesWrapper.classList.toggle('active');
		subcategoriesOverlay.classList.toggle('active');
	}

	btnSubcategoriesDesktop.addEventListener('click', () => {
		subcategoriesPopup();
	})
	btnSubcategoriesMobile.addEventListener('click', () => {
		subcategoriesPopup();
	})
	btnClose.addEventListener('click', () => {
		subcategoriesPopup();
	})
	subcategoriesOverlay.addEventListener('click', () => {
		subcategoriesPopup();
	})
}